/**
 * EltJobExecutionStatusBadge Component
 *
 * Visual indicator for job execution status.
 */

import React from "react";
import type { EltJobExecutionStatus } from "../../../types/elt-job-execution.types";

interface EltJobExecutionStatusBadgeProps {
  status: EltJobExecutionStatus;
}

const statusConfig: Record<EltJobExecutionStatus, { label: string; className: string; pulse: boolean }> = {
  pending: {
    label: "Pending",
    className: "bg-blue-100 text-blue-800 border-blue-200",
    pulse: true,
  },
  in_progress: {
    label: "In Progress",
    className: "bg-yellow-100 text-yellow-800 border-yellow-200",
    pulse: true,
  },
  succeeded: {
    label: "Succeeded",
    className: "bg-green-100 text-green-800 border-green-200",
    pulse: false,
  },
  failed: {
    label: "Failed",
    className: "bg-red-100 text-red-800 border-red-200",
    pulse: false,
  },
  cancelled: {
    label: "Cancelled",
    className: "bg-gray-100 text-gray-800 border-gray-200",
    pulse: false,
  },
};

export const EltJobExecutionStatusBadge: React.FC<EltJobExecutionStatusBadgeProps> = ({ status }) => {
  const config = statusConfig[status];

  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border ${config.className}`}>
      {config.pulse && (
        <span className="relative flex h-2 w-2">
          <span
            className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${
              status === "pending" ? "bg-blue-400" : "bg-yellow-400"
            }`}
          />
          <span className={`relative inline-flex rounded-full h-2 w-2 ${status === "pending" ? "bg-blue-500" : "bg-yellow-500"}`} />
        </span>
      )}
      {config.label}
    </span>
  );
};
